<template>
    <tr v-if="row && row.item && row.item.name">
        <td>
            <input type="hidden" name="id" :value="row.id" />
            <b v-if="hasValue(row.online_pharmacy)">
                {{ recordName }}
            </b>
            <router-link
                v-else-if="itemTypeId == LAB_TYPE && isNewLabProfile"
                :to="{
                    name: 'lab',
                    params: {
                        id: row.id,
                        patientName: row.patient.name,
                        patientId: row.patient.encoded_id
                    }
                }"
            >
                {{ recordName }}
            </router-link>
            <a
                v-else-if="
                    itemTypeId == LAB_TYPE &&
                    row.soap &&
                    row.soap.id &&
                    !isNewLabProfile
                "
                :href="getSoapLabLink()"
                v-html="recordName"
            ></a>
            <a
                v-else-if="itemTypeId == LAB_TYPE && !isNewLabProfile"
                :href="getPatientLabLink()"
                v-html="recordName"
            ></a>
            <b
                v-else-if="isEditable && _hasAccess('patient.record.update')"
                class="text-primary cursor-pointer"
                @click="editRecord(row)"
            >
                {{ recordName }}
                <span
                    v-if="
                        Object.keys(row.return_item).length > 0 &&
                        row.invoice_item &&
                        row.invoice_item.isfullreturn
                    "
                >
                    (Returned)
                </span>
            </b>
            <b
                v-else-if="
                    !isEditable && Object.keys(row.return_item).length > 0
                "
            >
                {{ recordName }} (Returned)
            </b>

            <b
                v-else
                class="text-primary cursor-pointer"
                @click="viewRecord(row)"
            >
                {{ recordName }}
            </b>
        </td>
        <td>{{ added }}</td>
        <td>
            <!-- summary -->
            <html-content
                content=" "
                :expanded="contentExpanded"
                more-text="View more"
                @onClickSeeMore="$emit('expand', row.id)"
                @onClickSeeLess="$emit('expand', null)"
            >
                <summary-generic
                    v-if="indexOf([5, 15, 16, 17, 18], itemTypeId) != -1"
                    :record="row"
                    @edit-diagnosis="editDiagnosis"
                ></summary-generic>
                <summary-vaccination
                    v-else-if="itemTypeId == 6"
                    :record="row"
                    @edit-diagnosis="editDiagnosis"
                ></summary-vaccination>
                <summary-lab
                    v-else-if="itemTypeId == LAB_TYPE"
                    :record="row"
                    @edit-diagnosis="editDiagnosis"
                ></summary-lab>
                <summary-default
                    v-else
                    :record="row"
                    @edit-diagnosis="editDiagnosis"
                ></summary-default>
            </html-content>
        </td>
        <!--
            EPIC-1000 : Medical Note migration
            Soap Record contains empty data for Reference column
            Patient Record contains data for Reference column
        -->
        <td v-if="isSoap">&nbsp;</td>
        <td v-else>
            <!-- soap -->
            <template v-if="isEditable">
                <div v-if="hasValue(row.online_pharmacy)">
                    <p>{{ getOnlineSource(row.source) }}</p>
                </div>
                <soap-link
                    v-if="
                        row.soap &&
                        Object.keys(row.soap).length > 0 &&
                        row.soap.isactive &&
                        row.soap.date
                    "
                    :soap="row.soap"
                />
            </template>
            <template v-else>
                <span v-if="row.soap && Object.keys(row.soap).length > 0">{{
                    row.soap.label
                }}</span>
            </template>
        </td>
        <td v-html="provider"></td>
        <!--
            EPIC-1000 : Medical Note migration
            Soap Record contains price data under Price column
            Patient Record contains created by data under Created by column
        -->
        <td v-if="isSoap">
            <template v-if="row.invoice_item && row.invoice_item.isactive">
                <span
                    v-if="
                        row.invoice_item.invoice &&
                        row.invoice_item.invoice.id &&
                        row.invoice_item.isactive
                    "
                >
                    {{ _toCurrency(row.invoice_item.total) }}
                </span>
            </template>
            <template v-else>
                <span v-if="row.IsMigrated || row.is_migrated">
                    Migrated Record
                </span>
            </template>
        </td>
        <td v-else v-html="createdBy"></td>
        <td>
            <!-- invoice -->
            <template v-if="isEditable">
                <template v-if="row.invoice_item && row.invoice_item.isactive">
                    <span v-if="!_hasAccess('billing.access')">{{
                        row.invoice_item.invoice.name
                    }}</span>
                    <a
                        v-else-if="
                            row.invoice_item.invoice &&
                            row.invoice_item.invoice.id &&
                            row.invoice_item.isactive
                        "
                        :href="getInvoiceLink(row.invoice_item)"
                    >
                        {{ row.invoice_item.invoice.name }}
                    </a>
                </template>
                <template v-else>
                    <span v-if="row.IsMigrated || row.is_migrated">
                        Migrated Record
                    </span>
                </template>
            </template>
        </td>
        <td class="text-right">
            <spinner v-if="processing == row.id" />
            <b-dropdown
                ref="dropdown"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                right
                lazy
                v-else-if="isEditable"
                :disabled="loadingDropdown"
                @toggle.prevent
            >
                <template v-slot:button-content>
                    <spinner v-if="loadingDropdown" @click.prevent.self />
                    <i
                        v-else
                        class="cus-cog-down"
                        @click.prevent.stop="openDropdown"
                    ></i>
                </template>

                <!-- Idexx Complete Order option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        _hasAccess('patient.record.create') &&
                        row.getLabSubmitUrl
                    "
                    @click="completeIdexxOrder(row)"
                >
                    <i class="cus-tick"></i>
                    Complete Order
                </b-dropdown-item>

                <!-- Antech HealthTracks option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        _hasAccess('patient.record.create') &&
                        row.antech_status &&
                        row.antech_status.antech_v6 &&
                        row.antech_status.status &&
                        row.antech_status.status != statuses.PRE_ORDER_STATUS &&
                        row.antech_status.lab_accession_id &&
                        row.antech_status.antech_token
                    "
                    @click="openHealthTrack(row.antech_status)"
                >
                    <i class="cus-tick"></i>
                    View HealthTracks
                </b-dropdown-item>

                <!-- Antech Complete Order option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        _hasAccess('patient.record.create') &&
                        row.antech_status &&
                        row.antech_status.antech_v6 &&
                        row.antech_status.immerse_url &&
                        (row.antech_status.status ==
                            statuses.PRE_ORDER_STATUS ||
                            row.antech_status.status == statuses.DRAFT) &&
                        isWithinValidPeriod
                    "
                    @click="completeAntechOrder(row.antech_status)"
                >
                    <i class="cus-tick"></i>
                    Complete Order
                </b-dropdown-item>

                <!-- Asteris option -->
                <b-dropdown-item
                    href="#"
                    v-if="showFetchAsterisResult(row)"
                    @click="fetchAsterisResult(row)"
                >
                    <i class="cus-arrow-refresh"></i>
                    Fetch Result
                </b-dropdown-item>

                <!-- znlabs addon test option -->
                <b-dropdown-item
                    href="#"
                    v-if="isZnLab"
                    @click="addAddonTest(row)"
                >
                    <i class="cus-add"></i>
                    New Add On Test
                </b-dropdown-item>

                <!-- attachment option -->
                <b-dropdown-item
                    href="#"
                    v-if="_hasAccess('patient.attachment.create')"
                    @click="addAttachmentViaHistory(row)"
                >
                    <i class="cus-add"></i>
                    New Attachment
                </b-dropdown-item>

                <!-- refill option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        row.summary &&
                        row.summary.refills > 0 &&
                        itemTypeId != GROOMING_ID &&
                        _hasAccess('patient.record.create') &&
                        row.item.isactive &&
                        row.summary.remainingRefill != 0 &&
                        !hasValue(row.online_pharmacy) &&
                        row.expire &&
                        _now().toFormat('X') <
                            _fromDateCarbon(row.expire).toFormat('X')
                    "
                    @click="refillRecord(row)"
                >
                    <i class="cus-add"></i>
                    New Refill
                </b-dropdown-item>

                <!-- edit option -->
                <template
                    v-if="
                        itemTypeId == LAB_TYPE &&
                        _hasAccess('patient.record.update') &&
                        !hasValue(row.online_pharmacy)
                    "
                >
                    <b-dropdown-item
                        v-if="isNewLabProfile"
                        :to="{
                            name: 'lab',
                            params: {
                                id: row.id,
                                patientName: row.patient.name,
                                patientId: row.patient.encoded_id
                            }
                        }"
                    >
                        <i class="cus-page-white-edit"></i>
                        Edit Record
                    </b-dropdown-item>
                    <b-dropdown-item
                        v-else-if="row.soap && row.soap.id"
                        :href="getSoapLabLink()"
                    >
                        <i class="cus-page-white-edit"></i>
                        Edit Record
                    </b-dropdown-item>
                    <b-dropdown-item v-else :href="getPatientLabLink()">
                        <i class="cus-page-white-edit"></i>
                        Edit Record
                    </b-dropdown-item>
                </template>
                <b-dropdown-item
                    href="#"
                    v-else-if="
                        _hasAccess('patient.record.update') &&
                        !hasValue(row.online_pharmacy)
                    "
                    @click="editRecord(row)"
                >
                    <i class="cus-page-white-edit"></i>
                    Edit Record
                </b-dropdown-item>

                <!-- duplicate option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        _hasAccess('patient.record.create') &&
                        !hasValue(row.online_pharmacy) &&
                        row.item.isactive &&
                        row.item.status
                    "
                    :disabled="isCubexEnabled"
                    v-b-tooltip.hover.top
                    :title="isCubexEnabled ? cubexTooltip : ''"
                    @click="duplicateRecord(row)"
                >
                    <i class="cus-page-copy"></i>
                    Duplicate Record
                </b-dropdown-item>

                <!-- print option -->
                <b-dropdown-item
                    href="#"
                    v-if="
                        row.isclinic == 1 &&
                        itemTypeId != GROOMING_ID &&
                        !hasValue(row.online_pharmacy)
                    "
                    @click="printLabel(row)"
                >
                    <i class="cus-printer"></i>
                    Print Label
                </b-dropdown-item>

                <!-- delete option -->
                <b-dropdown-item
                    href="#"
                    v-if="_hasAccess('patient.record.delete') && isDeletable"
                    @click="deleteRecord(row)"
                >
                    <i class="cus-delete"></i>
                    Delete Record
                </b-dropdown-item>

                <!-- decline option -->
                <b-dropdown-item
                    href="#"
                    v-if="isCanDeclineItem"
                    @click="declineItem(row)"
                >
                    <i class="cus-page-delete"></i>
                    Decline Item
                </b-dropdown-item>

                <!-- view history option -->
                <b-dropdown-item href="#" @click="viewHistoryRecord(row)">
                    <i class="fas fa-book"></i>
                    <span style="padding-left: 15px;">View Changes</span>
                </b-dropdown-item>
            </b-dropdown>
        </td>
    </tr>
</template>
<script>
import { indexOf, isEmpty, capitalize } from "lodash";
import BILLINGS from "@/constants/billings";
import SummaryLab from "@/components/medical-records/record-summary-lab";
import SummaryDefault from "@/components/medical-records/record-summary-default";
import SummaryGeneric from "@/components/medical-records/record-summary-generic";
import SummaryVaccination from "@/components/medical-records/record-summary-vaccination";
import RecordService from "@/services/records";
import ScheduleHelper from "@/module/schedule/helper";
import EXTENSIONS from "@/constants/extensions";
import LAB from "@/constants/lab";
import PaymentService from "@/services/payment.js";
import CubexMixin from "@/mixins/cubex";

const PAYMENT_FAILURE = "Payment Failure";
const COMPLETE = "Complete";
const CUBEX_DISPENSED = "Dispensed";

export default {
    components: {
        Spinner: () => import("@/components/elements/spinner"),
        SoapLink: () => import("@/components/commons/soap-link"),
        HtmlContent: () => import("@/components/commons/html-content"),
        SummaryLab,
        SummaryDefault,
        SummaryGeneric,
        SummaryVaccination
    },
    mixins: [ScheduleHelper, CubexMixin],
    props: {
        row: {
            type: Object,
            default: null
        },
        processing: {
            type: String,
            default: null
        },
        contentExpanded: {
            type: Boolean,
            default: false
        },
        isNewLabProfile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            indexOf,
            GROOMING_ID: 20,
            LAB_TYPE: 7,
            uri: "",
            added: "",
            summary: "",
            soap: "",
            provider: "",
            updatedBy: "",
            createdBy: "",
            invoice: "",
            options: "",
            recordName: "",
            itemTypeId: 0,
            lotString: "",
            statuses: {
                COMPLETED: COMPLETE,
                PAYMENT_FAILURE: PAYMENT_FAILURE,
                PRE_ORDER_STATUS: LAB.ANTECH_STATUS.PRE_ORDER,
                DRAFT: LAB.ANTECH_STATUS.DRAFT
            },
            loadingDropdown: false,
            isHasAuditStatus: false,
            cubexTooltip:
                "This functionality is not currently available when the Cubex Integration is enabled"
        };
    },
    computed: {
        isSoap() {
            return this.$route.name === "soap";
        },
        isCubexEnabled() {
            return this.isCubexItem(this.row);
        },
        isDeletable() {
            if (this.row.invoice_item && this.row.invoice_item.isactive) {
                if (
                    this.row.invoice_item.invoice &&
                    (this.row.invoice_item.invoice.status ===
                        BILLINGS.INVOICE.TYPE_PAID ||
                        this.row.invoice_item.invoice.status ===
                            BILLINGS.INVOICE.TYPE_WRITEOFF)
                ) {
                    return false;
                }
            }

            /**
             * Cannot delete record if it is online_pharmacy
             * EXCEPT for VETSOURCE online pharmacy
             */
            if (this.hasValue(this.row.online_pharmacy)) {
                return (
                    this.row.online_pharmacy.source ===
                    EXTENSIONS.CODE.CODE_VETSOURCE
                );
            }

            return true;
        },
        isEditable() {
            return (
                this.row.business &&
                this.row.business.id === this._setting.business_id
            );
        },
        isWithinValidPeriod() {
            if (this.row.antech_status && this.row.antech_status.order_date) {
                let orderDate = this._toDateTime(
                    this.row.antech_status.order_date?.date
                );

                let duration = this._now().diff(orderDate, ["days"]).toObject();
                let period = LAB.ANTECH_VALIDITY_PERIOD + 1;

                return duration && duration.days < period;
            }

            return false;
        },
        isZnLab() {
            return (
                this.row.source &&
                this.row.source.toUpperCase() == EXTENSIONS.CODE.CODE_ZNLABS
            );
        },
        isCanDeclineItem() {
            return (
                !this.isSoap &&
                this.isDeletable &&
                this._hasAccess("billing.invoice.item.decline") &&
                this._hasAccess("patient.record.delete") &&
                this.row.invoice_item &&
                this.row.invoice_item.invoice &&
                this.row.invoice_item.invoice.status ===
                    BILLINGS.INVOICE.TYPE_OPEN
            );
        }
    },
    mounted() {
        this.row && this.row.item ? this.init(this.row) : "";
    },
    methods: {
        init(object) {
            let recordName = object.item_name;
            let added = "";
            let provider = "";
            let updatedBy = "";
            let createdBy = "";

            let isEditable = this.isEditable;

            if (recordName == "" || recordName == null) {
                recordName = object.item.name;
            }

            if (
                Object.keys(object.return_item).length > 0 &&
                object.invoice_item &&
                object.invoice_item.isfullreturn &&
                object.item.type == this.LAB_TYPE
            ) {
                recordName = recordName + " " + "(Returned)";
            }

            if (!isEmpty(object.date)) {
                added = this._carbonDateTimeDisplay(object.date);
            } else if (!isEmpty(object.create_at)) {
                added = this._carbonDateTimeDisplay(object.create_at);
            }

            if (object.prescribed_by) {
                provider = object.prescribed_by.display_name;
                if (object.business) {
                    provider = provider + "<br/>(" + object.business.name + ")";
                }
            } else {
                provider = object.default_provider
                    ? object.default_provider.display_name
                    : "";
            }

            if (object.update_by) {
                updatedBy = object.update_by.display_name;
                if (object.business) {
                    updatedBy =
                        updatedBy + "<br/>(" + object.business.name + ")";
                }
            }

            if (object.create_by) {
                createdBy = object.create_by.display_name;
                if (object.business) {
                    createdBy =
                        createdBy + "<br/>(" + object.business.name + ")";
                }
            }

            let item_type_id = 0;
            if (object.item.item_type) {
                item_type_id = object.item.item_type.id;
            }

            if (isEditable) {
                if (object.prescribed_by) {
                    provider = object.prescribed_by.display_name;
                } else {
                    provider = object.default_provider
                        ? object.default_provider.display_name
                        : "";
                }
                if (object.update_by) {
                    updatedBy = object.update_by.display_name;
                }
                if (object.create_by) {
                    createdBy = object.create_by.display_name;
                }
            }

            if (Array.isArray(object.updateBy) && object.updateBy.length == 0) {
                updatedBy = "Automatic";
            }

            if (Array.isArray(object.createBy) && object.createBy.length == 0) {
                createdBy = "Automatic";
            }

            this.added = added;
            this.provider = provider;
            this.updatedBy = updatedBy;
            this.createdBy = createdBy;

            this.recordName = recordName;
            this.itemTypeId = item_type_id;
        },
        editRecord(row) {
            this.$emit("edit", row);
        },
        viewRecord(row) {
            this.$emit("view", row);
        },
        refillRecord(row) {
            this.$emit("refill", row);
        },
        addAddonTest(row) {
            this.$emit("add-addon-test", row);
        },
        duplicateRecord(row) {
            this.$emit("duplicate", row);
        },
        deleteRecord(row) {
            this.$emit("delete", row);
        },
        declineItem(row) {
            this.$emit("decline-items", row);
        },
        viewHistoryRecord(row) {
            this.$emit("history", row);
        },
        addAttachmentViaHistory(row) {
            this.$store.commit("patient/openModalNewAttachment", {
                action: "add",
                module: this.MODULE.PATIENT,
                patient_id: this.row.patient.id,
                record_id: row.id,
                record_type: row.type,
                soap_id: row.soap_id
            });
        },
        printLabel(row) {
            this.$emit("print", row);
        },
        getSoapLabLink() {
            return (
                process.env.APPS +
                "soap/lab/view/" +
                this.row.soap.id +
                "/" +
                this.row.id
            );
        },
        getSoapViewLink() {
            return process.env.APPS + this.row.soap.ci_url;
        },
        getViewPatientLabLink() {
            return "/view/patient/lab/" + this.row.id;
        },
        getPatientLabLink() {
            return (
                process.env.APPS +
                "patient/lab/view/" +
                this.row.patient.id +
                "/" +
                this.row.id
            );
        },
        getInvoiceLink(invoice) {
            return (
                process.env.APPS +
                "billing/invoice/view/" +
                invoice.invoice.encoded_id
            );
        },
        editDiagnosis(diagnosis) {
            this.$emit("edit-diagnosis", diagnosis);
        },
        getOnlineSource(source) {
            let sourceName = source.toUpperCase();

            sourceName = source.includes("ONLINE")
                ? source.split("_")[0]
                : source;

            return capitalize(sourceName);
        },
        hasValue(obj) {
            if (obj === null) {
                return false;
            }

            const keys = Object.keys(obj);
            return keys.length > 0;
        },
        async openDropdown() {
            if (this.row?.invoice_item?.invoice?.id) {
                await this.checkRecordInvoiceStatus();
                await this.$nextTick();
            }
            this.$refs.dropdown.show();
        },

        async checkRecordInvoiceStatus() {
            if (
                this.isDeletable &&
                (!this.$parent.$refs.historyPagination ||
                    this.$parent.$refs.historyPagination?.pagination
                        ?.currentPage == 1)
            ) {
                this.loadingDropdown = true;
                let response = await PaymentService.checkInvoiceStatus({
                    invoices: [this.row.invoice_item.invoice.id]
                });
                if (response && response.code == 200) {
                    this.$emit(
                        "update-invoice-status",
                        this.row.id,
                        response.resources[0]
                    );
                }
                this.loadingDropdown = false;
            }
        },

        completeIdexxOrder(param) {
            let self = this;

            const getLabSubmitUrl = param.getLabSubmitUrl;
            const lab_id = param.lab_id;
            const lab_extension = param.lab_extension;

            if (getLabSubmitUrl && lab_id && lab_extension) {
                let print_lab_params = {
                    idexx_lab_id: lab_id,
                    idexx_url: [getLabSubmitUrl],
                    lab_ids: [lab_id],
                    source: lab_extension,
                    module: "appointment"
                };

                self._print_lab_order(print_lab_params).then(function (
                    lab_response
                ) {
                    if (lab_response.idexx_iframe) {
                        //load idexx iframe
                        self.$root.$emit("call_idexx_iframe", lab_response);
                    }
                });
            }
        },
        showFetchAsterisResult(row) {
            if (
                row &&
                row.source &&
                row.source === EXTENSIONS.CODE.CODE_ASTERIS
            ) {
                if (row.summary && row.summary.imaging_link) {
                    // NOTE: Asteris record already have result
                    return false;
                }
                return true;
            }

            return false;
        },
        async fetchAsterisResult(row) {
            const recordId = row.id;

            if (recordId) {
                try {
                    const response = await RecordService.fetchAsterisResult(
                        recordId
                    );

                    if (response) {
                        if (response.code == 200) {
                            this._message(response.resource.message);
                        } else {
                            this._message(response.message, "danger");
                        }
                    }
                } catch (error) {
                    this._message(error.message, "danger");
                }
            }
        },
        completeAntechOrder(param) {
            const antechParam = {
                ...param,
                accession_id: [param.accession_id]
            };

            this.$root.$emit("call-antech-iframe", antechParam);
        },
        openHealthTrack(param) {
            this.$root.$emit("call-antech-healthtracks-iframe", {
                lab_accession_id: param.lab_accession_id,
                access_token: param.antech_token
            });
        }
    }
};
</script>
